import { ChatProviderType } from '../../../../domain/chat/models/ChatProviderType';
import { AssistantsChatSession, AssistantType } from '../../../../domain/chat/models/ChatSession';
import { AssistantChatSessionDto } from '../dtos/responses/AssistantChatSessionDto';


const toTimestamp = (value: string | number | undefined): number | undefined => {
    if (value === undefined || value === null) {
        return undefined;
    }

    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? undefined : timestamp;
};

const isEngagementAcceleratorChat = (dto: AssistantChatSessionDto): boolean => {
    return !!(
        dto.parentChatSessionId ||
        (dto.engagementAccelerator && dto.engagementAccelerator.length > 0) ||
        (dto.engagementFiles && dto.engagementFiles.length > 0) ||
        (dto.processedEngagementFiles && dto.processedEngagementFiles.length > 0)
    );
};

export const mapAssistantChatSessionDtoToModel = (
    dto: AssistantChatSessionDto,
): AssistantsChatSession => {
    const assistantType = isEngagementAcceleratorChat(dto)
        ? AssistantType.Engagement
        : AssistantType.Standard;

    return {
        id: dto.id,
        userId: dto.userId ?? '',
        title: dto.title,
        agentId: dto.customGPTId ?? '',
        providerType: ChatProviderType.Assistants,
        createdDate: toTimestamp(dto.createdDate) ?? 0,
        modifiedDate: toTimestamp(dto.modifiedDate),
        isTitleGenerated: dto.isTitleGenerated,
        threadRunConfig: dto.threadRunConfig ?? undefined,
        attachedFiles: dto.attachedFiles ?? undefined,
        blobFiles: dto.blobFiles ?? undefined,
        shellId: dto.shellId ?? undefined,
        parentChatSessionId: dto.parentChatSessionId ?? undefined,
        assistantType,
        engagementAccelerator: dto.engagementAccelerator ?? undefined,
        engagementFiles: dto.engagementFiles ?? undefined,
        processedEngagementFiles: dto.processedEngagementFiles ?? undefined,
    };
};

